var render = function render(){var _vm=this,_c=_vm._self._c;return _c('materials',{attrs:{"show-export-xls":true,"show-client-selection":false,"need-client-id":true,"show-county-paramedic-tab":true},on:{"loadCategories":_vm.loadClientCategories,"loadDocuments":_vm.loadClientDocuments,"exportDocuments":_vm.exportClientDocuments}})
}
var staticRenderFns = []

export { render, staticRenderFns }